module.exports = __webpack_public_path__ + "img/type5.0cfe8292.png";